import { render, staticRenderFns } from "./carDataStatistics.vue?vue&type=template&id=cd591ba0&scoped=true&"
import script from "./carDataStatistics.vue?vue&type=script&lang=js&"
export * from "./carDataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./carDataStatistics.vue?vue&type=style&index=0&id=cd591ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd591ba0",
  null
  
)

export default component.exports